import { FormGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import TextWidget from "common/form/widgets/TextWidget";
import Icon from "common/views/icon/Icon";
import Label from "core/components/label/Label";
import { ILinkType, IStaticLinkData, LinkTypeRegistry } from "../ILinkType";
import { IMenuNode } from "../MenuTree.view";

type IContainerLink = IStaticLinkData;

const containerLinkType: ILinkType<IContainerLink> = {
	type: "container",
	label: "Container/Sub Menu",
	icon: IconNames.LIST,
	renderInput: (value: IContainerLink, onChange: (value: IContainerLink) => void) => (
		<React.Fragment>
			<FormGroup label="Label">
				<TextWidget onChange={(label) => onChange({...value, label})} value={value.label} />
			</FormGroup>
			<FormGroup label="Icon">
				<TextWidget onChange={(icon) => onChange({...value, icon})} value={value.icon} />
			</FormGroup>
			<FormGroup label="Icon Type">
				<ButtonSelect
					onChange={(iconType: "bp" | "external") => onChange({...value, iconType})}
					options={[
						{value: "bp", label: "Blueprint"},
						{value: "external", label: "External"}
					]}
					value={value.iconType || "bp"}
				/>
			</FormGroup>
		</React.Fragment>
	),
	mapDataToMenuNode: (data: IContainerLink, props): IMenuNode<IContainerLink> => {

		return {
			...props,
			label: <Label k={`link.${props.id}`} v={data.label} />,
			icon: <Icon icon={IconNames.CHEVRON_DOWN} />,
			isSelectable: false
		};
	}
};

export default LinkTypeRegistry.registerType(containerLinkType);



// WEBPACK FOOTER //
// ./src/common/views/menuTree/linkTypes/ContainerLink.tsx